import { render, staticRenderFns } from "./zCopyClipboard.vue?vue&type=template&id=9d190a6e&scoped=true&"
import script from "./zCopyClipboard.vue?vue&type=script&setup=true&lang=js&"
export * from "./zCopyClipboard.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d190a6e",
  null
  
)

export default component.exports